/**
 * Shared GHP constants for the html/js build pipeline.
 *
 * The session-storage key is also referenced from the theme TS bundle
 * (`src/wp-content/themes/eaplus/src/ghp/lib/navigation.ts`) — keep the
 * two literals in sync when renaming.
 */

export const GHP_SESSION_KEY = "ghpSeeMyPrice";
